const ConvertBase64ToFile = (base64, filename, type) => {
  // Decode the Base64 string
  const byteCharacters = atob(base64);

  // Create a Uint8Array to hold the byte data
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  // Create a File object
  return new File([byteArray], filename, { type: type });
};

export default ConvertBase64ToFile;
